// NatGen Google Floodlight snippet for starting a quote
export function natgenFloodlightQuoteStart() {
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'u1': '1',
        'send_to': 'DC-1886972/natg694/ngbey00+unique'
    });
}
